import React from "react";
import ReactApexChart from "react-apexcharts";

const LoanChartComponent = ({ loanTypes }) => {
  const categories = Array.isArray(loanTypes)
    ? loanTypes.map(item => item.name + ` (${item.loan_count})`)
    : [];

  const data = Array.isArray(loanTypes)
    ? loanTypes.map(item => item.loan_count)
    : [];

  const chartData = {
    series: [
      {
        name: "Loan Count",
        data: data || [],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: true,
          distributed: true,
          barHeight: "80%",
          isFunnel: true,
        },
      },
      colors: [
        "#F44F5E",
        "#E55A89",
        "#D863B1",
        "#CA6CD8",
        "#B57BED",
        "#8D95EB",
        "#62ACEA",
        "#4BC3E6",
        "#4BC3E6",
        "#4BC3E6",
      ],
      dataLabels: {
        enabled: true,
        formatter: function (val, opt) {
          return opt?.w?.globals?.labels?.[opt.dataPointIndex] || "";
        },
        dropShadow: { enabled: true },
      },
      title: {
        text: "Loan Category",
        align: "middle",
      },
      xaxis: {
        categories: categories || [],
      },
      legend: { show: false },
    },
  };

  return (
    <div>
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default LoanChartComponent;
